import { ResponsiveVisibility, Text, Skeleton, HStack } from '@genial/components';
import { BoxRadius, Spacing } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import { Box } from 'native-base';
import React, { useMemo } from 'react';

import { chartValues } from '../../constants';

export namespace ChartLegendOutsideTypes {
  export interface Props {
    visibility?: ResponsiveVisibility;
    loading?: boolean;
  }
}

export const ChartLegendOutside: React.FC<ChartLegendOutsideTypes.Props> = ({
  visibility,
  loading,
}) => {
  const sanitizedVisibility: NonNullable<ResponsiveVisibility> = visibility ?? {};
  const currentVisibility = useBreakpointValue(
    typeof sanitizedVisibility === 'string' ? { base: sanitizedVisibility } : sanitizedVisibility
  );

  const legendItems = useMemo(() => {
    return Object.entries(chartValues).map(([key, value]) => {
      if (loading) {
        return <Skeleton key={key} height="inset.sm" width="110px" borderRadius="sm" />;
      }

      return (
        <HStack key={key} space={Spacing['stack.quarck']}>
          <Box w="4px" backgroundColor={value.color} borderRadius={BoxRadius.xs} />
          <Text>{value.name}</Text>
        </HStack>
      );
    });
  }, [loading]);

  if (currentVisibility === 'hidden') {
    return null;
  }

  return (
    <HStack alignItems="center" space={Spacing['stack.nano']}>
      {legendItems}
    </HStack>
  );
};
